import ReportView, { type ReportColumn, type ReportOption } from '../../../components/reports/ReportView';

// TS port of the source (Falah) app's pages/reports/procurement/OrderRegisterReport.jsx.
const STATUS_OPTIONS: ReportOption[] = [
  { value: 'issued', label: 'Issued' },
  { value: 'sent_to_vendor', label: 'Sent to Vendor' },
  { value: 'partially_fulfilled', label: 'Partially Fulfilled' },
  { value: 'completed', label: 'Completed' },
  { value: 'cancelled', label: 'Cancelled' },
];

const COLUMNS: ReportColumn[] = [
  { key: 'po_number', label: 'PO #' },
  { key: 'reference', label: 'Request Ref' },
  { key: 'vendor_name', label: 'Vendor' },
  { key: 'amount', label: 'Amount', align: 'right', type: 'money' },
  { key: 'delivery_date', label: 'Delivery Date' },
  { key: 'payment_terms', label: 'Payment Terms' },
  { key: 'status', label: 'Status' },
  { key: 'issued_by', label: 'Issued By' },
];

export function OrderRegisterReport() {
  return (
    <ReportView
      title="Purchase Order Register"
      description="Purchase orders issued, with vendor, amount and delivery date."
      endpoint="/reports/procurement/order-register"
      columns={COLUMNS}
      filters={['status', 'dateRange']}
      statusOptions={STATUS_OPTIONS}
    />
  );
}
